import axios from 'axios'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

const BASE_URL = `${
  (window as any)?._env_?.REACT_APP_ELPHA_BACKEND_URL !== undefined
    ? (window as any)?._env_?.REACT_APP_ELPHA_BACKEND_URL
    : process.env.REACT_APP_ELPHA_BACKEND_URL
}`

// const STRIPE_API_SAAS = `${
//   (window as any)?._env_?.REACT_APP_STRIPE_API_SAAS !== undefined
//     ? (window as any)?._env_?.REACT_APP_STRIPE_API_SAAS
//     : process.env.REACT_APP_STRIPE_API_SAAS
// }`;
// interface API_DATA {
//   organization_name: string | null;
//   licenses: number | null;
// }

export const useGetSaaSBillingInfo = () => {
  return useMutation(
    (values: {
      organization_name: string | null
      licenses: number | null
      package: string | null
      email: string | null
      zipcode?: string | null
    }) =>
      axios
        .post(
          `${BASE_URL}/public/payment/saas`,
          { ...values, zipcode: values.zipcode === '' ? null : values.zipcode },
          {
            headers: {
              ApiKey:
                'HQtgFE6SM2EY32qcfzr6TuXqiLAAzzBK4jmtkdbCf5LmsZ8UPTewejAvJNGbWL7e',
            },
          }
        )
        .then((res) => res.data),
    {
      onError: (error, variables, context) => {
        toast.error(
          `Uh oh. There was an issue getting billing information. Please contact us if the problem persists.`
        )
      },
    }
  )
}
